/* Cappa — minimal theme behaviour. No dependencies. */
(function () {
  // hero slideshow: scroll-snap track with dots and optional autoplay
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var track = hero.querySelector('[data-hero-track]');
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    if (!track) return;
    var slides = track.children.length;
    var i = 0;

    function go(n) {
      i = (n + slides) % slides;
      // same reason as the product rows: assign scrollLeft, let CSS animate it
      track.scrollLeft = track.clientWidth * i;
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });

    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== i) { i = n; dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); }); }
    }, { passive: true });

    var every = parseInt(hero.dataset.autoplay || '0', 10);
    if (every > 0 && slides > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var timer = setInterval(function () { go(i + 1); }, every * 1000);
      hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  });

  // product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.dataset.full; main.srcset = ''; }
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // variant picker: rebuild the option string and match it against the variant list
  document.querySelectorAll('[data-variants]').forEach(function (form) {
    var data = JSON.parse(form.querySelector('[data-variant-json]').textContent);
    var idField = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');

    function selected() {
      return Array.prototype.slice.call(form.querySelectorAll('[data-option]'))
        .map(function (s) { return s.value; });
    }
    function update() {
      var want = selected().join(' / ');
      var v = data.find(function (x) { return x.title === want; });
      if (!v) return;
      idField.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;

      // Subscription plans are priced per variant, so rebuild the purchase options
      // whenever the variant changes. The previously chosen plan is kept if the new
      // variant still offers it, otherwise it falls back to the one-time purchase.
      // Blend slots follow the variant: one per bag in the box.
      var blendBox = form.querySelector('[data-blends]');
      if (blendBox) {
        var want = v.slots || 1;
        blendBox.querySelectorAll('[data-blend-slot]').forEach(function (slot) {
          var on = parseInt(slot.dataset.blendSlot, 10) <= want;
          slot.hidden = !on;
          slot.querySelectorAll('select').forEach(function (sel) { sel.disabled = !on; });
        });
        var c = blendBox.querySelector('[data-blends-count]');
        if (c) c.textContent = want;
        var hd = blendBox.querySelector('[data-blends-head]');
        if (hd) hd.innerHTML = 'Choose your <span data-blends-count>' + want + '</span> coffee' + (want > 1 ? 's' : '');
      }

      var planBox = form.querySelector('[data-plans]');
      if (planBox) {
        var checked = planBox.querySelector('input[name="selling_plan"]:checked');
        var keep = checked ? checked.value : '';
        var plans = v.plans || [];
        if (!plans.length) {
          planBox.hidden = true;
          planBox.innerHTML = '';
        } else {
          planBox.hidden = false;
          var html = '<legend>Purchase options</legend>' +
            '<label class="pdp__plan"><input type="radio" name="selling_plan" value="">' +
            '<span>One-time purchase</span>' +
            '<span class="pdp__plan-price">' + v.price_html + '</span></label>';
          plans.forEach(function (pl) {
            html += '<label class="pdp__plan"><input type="radio" name="selling_plan" value="' + pl.id + '">' +
              '<span>' + pl.name + '</span>' +
              '<span class="pdp__plan-price">' + pl.price_html + '</span></label>';
          });
          planBox.innerHTML = html;
          var restore = planBox.querySelector('input[name="selling_plan"][value="' + keep + '"]');
          (restore || planBox.querySelector('input[name="selling_plan"]')).checked = true;
        }
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.label : 'Sold out';
      }
    }
    form.querySelectorAll('[data-option]').forEach(function (s) { s.addEventListener('change', update); });
    update();
  });


  // Product rows page by whole cards.
  //
  // Two things that broke this before: scrollBy({behavior:'smooth'}) fights a
  // mandatory scroll-snap container (Safari cancels the animation outright), and
  // paging by clientWidth ignores the gap, so the row drifts off the card grid.
  // Assigning scrollLeft with CSS scroll-behavior doing the animation is honoured
  // everywhere, and the target is computed from the real card pitch.
  document.querySelectorAll('[data-rowx]').forEach(function (row) {
    var head = row.closest('.section').querySelector('[data-rowx-nav]');
    if (!head) return;
    var prev = head.querySelector('[data-rowx-prev]');
    var next = head.querySelector('[data-rowx-next]');

    function pitch() {
      var first = row.firstElementChild;
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function maxScroll() { return row.scrollWidth - row.clientWidth; }

    function sync() {
      var scrollable = maxScroll() > 4;
      head.hidden = !scrollable;
      if (!scrollable) return;
      prev.disabled = row.scrollLeft < 4;
      next.disabled = row.scrollLeft > maxScroll() - 4;
    }
    function page(dir) {
      var step = pitch();
      if (!step) return;
      var per = Math.max(1, Math.round(row.clientWidth / step));
      var target = (Math.round(row.scrollLeft / step) + dir * per) * step;
      row.scrollLeft = Math.min(Math.max(target, 0), maxScroll());
      sync();
    }
    prev.addEventListener('click', function () { page(-1); });
    next.addEventListener('click', function () { page(1); });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });

  // quantity stepper
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, n + parseInt(b.dataset.step, 10));
      });
    });
  });

  // mobile drawer
  var toggle = document.querySelector('[data-nav-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  if (toggle && drawer) {
    var openDrawer = function () {
      drawer.classList.add('is-open');
      document.body.classList.add('no-scroll');
      toggle.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('.drawer__close');
      if (first) first.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) { closeDrawer(); toggle.focus(); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 990 && drawer.classList.contains('is-open')) closeDrawer();
    });
    // submenus are accordions: there is no hover on a phone
    drawer.querySelectorAll('[data-drawer-sub]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.drawer__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // transparent header sits below the announcement bar, then solidifies on scroll
  var hdr = document.querySelector('[data-hdr-transparent]');
  if (hdr) {
    var ann = document.querySelector('[data-announcement]');
    var measure = function () {
      document.documentElement.style.setProperty('--ann-h', (ann ? ann.offsetHeight : 0) + 'px');
    };
    var onScroll = function () {
      hdr.classList.toggle('hdr--transparent', window.scrollY < 80);
    };
    measure();
    onScroll();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
